import axios from 'axios'
import services from '@/config/services'
import authHeader from '@/services/auth/auth-header'

export default class AllianzService {
  constructor(http, eventBus) {
    this.http = http || axios
    this.eventBus = eventBus
    this.apiUrl = `${services.ask_pratiche.url}/checkAllianz`

    axios.interceptors.request.use((req) => {
      req.headers['Authorization'] = authHeader()
      return req
    })
  }

  async getStatus() {
    const res = await this.http.get(this.apiUrl)
    return res.data
  }
}
